<template>
  <div id="app">
    <div v-if="!load">
      <router-view/>
      <div id="audio-modal" class="modal-overlay" v-if="modalSom" @click="ativarSom()">
        <div class="modal-audio shadow">
          <h6 class="mb-1 text-primary">Ativar som</h6>
          <p class="small mb-0">
            Para ouvir os alertas e sons do sistema, clique em qualquer lugar da tela.
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center bg-primary" style="height: 100vh" v-else>
      <div class="m-auto text-center">
        <img src="./assets/logo-white.png" alt="Logo Lecard" style="width: 184px;">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        load: true,
        user: {},
        modalSom: false
      }
    },

    methods: {
      autenticar() {
        const cacheUser = this.$cache.get("usuario");

        if (cacheUser) {
          this.initApp(cacheUser);
        }

        this.$http.get('auth/me')
          .then(res => {
            if (!res.data.success) {
              this.$swal("Atenção!", "Não conseguimos autenticar. Por favor tente novamente!");
              return;
            }

            if (!cacheUser) {
              this.$cache.set("usuario", res.data);
              this.initApp(res.data);
            }

          }, res => {
            if (res.status === 401) {
              this.load = false;
            }
          });
      },

      initApp(data) {
        const agent = data.agent;

        if (agent) {
          agent.session = this.$helpers.ID();
          this.$store.commit('setDataUser', agent);
          this.user = agent;
          this.$store.state.alerts = !!this.user.alerts;
        }

        if (!agent.is_connect) {
          if (this.$route.name !== 'Connect') {
            this.$router.push('/conectar');
          }

        } else if (!['Lebot','Config'].includes(this.$route.name)) {
          this.$router.push('/chat');
        }

        this.modalSom = !this.isElectron;

        if (!this.modalSom) {
          this.ativarSom();
        }

        this.load = false;
      },

      ativarSom() {
        this.modalSom = false;
        this.$store.state.canPlay = true;
      }
    },

    mounted() {
      if (localStorage.getItem('refresh_token')) {
        this.autenticar();

      } else {
        this.load = false;

        if (this.$route.name !== 'Login') {
          this.$router.push('/login');
        }
      }
    },

    sockets: {
      new_message(res)  {
        if (!res.is_me && !this.$route.name.startsWith('Lebot')) {
          this.$store.commit('setBell', 1);
          this.playNewMessage();
        }
      },

      new_chat_order(data) {
        if (data && !this.$route.name.startsWith('Lebot')) {
          new Notification('Solicitação de atendimento!', {
            body: 'Um cliente solicitou atendimento',
            icon: document.getElementById('imgEmpresa').src
          });

          this.playNotification();
        }
      }
    },
  }
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9999;
}

.modal-audio {
  position: absolute;
  top: 16px;
  right: 20px;
  background: #ffffff;
  padding: 15px;
  width: 320px;
  border-radius: 8px;
  border: 1px solid #ccc;
  animation: slideInRight 0.35s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
